import { Stack, styled, Typography } from '@planne-software/uni/mui/material';

export const Container = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  gap: theme.tokens.spacing['spacing-1xmini'],
  padding: theme.tokens.spacing['spacing-1xmini'],
  backgroundColor: theme.tokens.colors['fill-color-accent-softest'],
  borderRadius: theme.tokens.radius['border-radius-2xs'],
}));

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-medium'],
  color: theme.tokens.colors['text-color-accent-base'],
  whiteSpace: 'nowrap',
}));
